import styled from "styled-components";
import { darken } from "@material-ui/core";

export const RadioWrapper = styled.div`
${({ theme }) => `
    &.radio--block {
        .radio__item {
            background: ${theme.lightColor};
            display: block;
            width: 100%;
            padding: 8px 24px;
            border-radius: ${theme.rounded.sm};
            cursor: pointer;

            &:hover {
                background: ${darken(theme.lightColor, .015)};
            }
        }
    }

    &.form-outline {
      .form-control.reset-form-control {
        display: block;
        width: 100%;
        padding: .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.6;
        color: ${theme.darkGreyColor};
        background-color: ${theme.white};
        background-clip: padding-box;
        border: 1px solid #bdbdbd;
        -webkit-appearance: none;
        appearance: none;
        border-radius: .25rem;
        transition: all .2s linear;

        &::placeholder {
          opacity: 1;
        }
      }
    }
`}
`;

export const Label = styled.label`
  font-size: 0.8rem;
`;

export const RadioLabel = styled.label`
  margin-right: 1rem;
`;

export const RadioContent = styled.div`
  ${({ theme }) => `
    background: ${theme.lightColor};
    margin-bottom: 1rem;
    margin-top: -.8rem;
    padding: 8px 24px 12px;
    border-radius: 0 0 ${theme.rounded.sm} ${theme.rounded.sm};

    .radio__item__body {
      border-top: 1px solid ${theme.darkGreyColor}50;
      padding-top: 8px;
    }
  `}
`;